import React from 'react';
import { Musterlogobgremove, yticon, fbicon, instaicon, whatsappicon } from '../assets/images';

const scrollTo = (id) => document.querySelector(id)?.scrollIntoView({ behavior: 'smooth' });

export default function Footer() {
  const colTtl = {
    fontFamily: 'var(--fh)', fontSize: '0.9rem', fontWeight: 600,
    letterSpacing: '0.2em', textTransform: 'uppercase',
    color: 'var(--gold)', marginBottom: '1.25rem',
  };
  const lnkBase = {
    fontSize: '0.95rem', color: 'var(--lt)', textDecoration: 'none',
    display: 'block', marginBottom: '0.6rem', background: 'none',
    border: 'none', cursor: 'pointer', fontFamily: 'var(--fb)',
    padding: 0, textAlign: 'left', transition: 'color .2s',
  };
  const hover = (e) => (e.currentTarget.style.color = 'var(--wh)');
  const leave = (e) => (e.currentTarget.style.color = 'var(--lt)');

  return (
    <footer style={{
      position: 'relative', zIndex: 1,
      background: 'rgba(240,240,240,0.97)',
      borderTop: '1px solid #1E2823',
      padding: '4rem 2rem 2rem',
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <div className="fg-grid" style={{ display: 'grid', gridTemplateColumns: '2fr 1fr 1fr 1fr', gap: '3rem', marginBottom: '3rem' }}>

          {/* Brand */}
          <div>
            <div style={{ marginBottom: '1rem' }}>
              <img
                src={Musterlogobgremove}
                alt="Muster logo"
                style={{ width: 180, height: 190, objectFit: 'fill', display: 'block', filter: 'brightness(0.2)' }}
              />
            </div>
            <p style={{ fontSize: '0.95rem', fontWeight: 500, color: 'var(--lt)', lineHeight: 1.7, maxWidth: 260, marginBottom: '1.25rem' }}>
              Muster Construct & Consultancy Services — turning dream homes into reality across Salem & Coimbatore since our founding.
            </p>
            {/* Contact quick-links */}
            <div style={{ fontSize: '0.92rem', color: 'var(--wh)', lineHeight: 2 }}>
              <div>
                <a href="tel:+918056332329" style={{ color: 'var(--wh)', textDecoration: 'none' }}>
                  📞 +91 80563 32329
                </a>
              </div>
              <div style={{ color: 'var(--gold)' }}>
                <a href="mailto:musterconstruct@gmail.com" style={{ color: 'var(--gold)', textDecoration: 'none' }}>
                  ✉ musterconstruct@gmail.com
                </a>
              </div>
            </div>
          </div>

          {/* Services */}
          <div>
            <div style={colTtl}>Services</div>
            {['Residential Building', 'Commercial Building', 'Tensile Structure', 'PEB Structure', 'Consultancy'].map(s => (
              <button key={s} onClick={() => scrollTo('#services')} style={lnkBase}
                onMouseEnter={hover} onMouseLeave={leave}>{s}</button>
            ))}
          </div>

          {/* Company */}
          <div>
            <div style={colTtl}>Company</div>
            {[['About Us', '#about'], ['Our Services', '#services'], ['Projects', '#projects'], ['Our Process', '#process'], ['Contact', '#contact']].map(([label, id]) => (
              <button key={label} onClick={() => scrollTo(id)} style={lnkBase}
                onMouseEnter={hover} onMouseLeave={leave}>{label}</button>
            ))}
          </div>

          {/* Locations */}
          <div>
            <div style={colTtl}>Locations</div>
            <div style={{ fontSize: '0.95rem', color: 'var(--lt)', lineHeight: 1.7 }}>
              <div style={{ color: 'var(--wh)', fontWeight: 500, marginBottom: '0.5rem' }}>Salem</div>
              <div style={{ marginBottom: '1rem', fontSize: '0.9rem' }}>Tamil Nadu, India</div>
              <div style={{ color: 'var(--wh)', fontWeight: 500, marginBottom: '0.5rem' }}>Coimbatore</div>
              <div style={{ fontSize: '0.9rem' }}>Tamil Nadu, India</div>
            </div>
            <div style={{ marginTop: '1.5rem' }}>
              <div style={colTtl}>Pricing</div>
              <div style={{ fontFamily: 'var(--fh)', fontSize: '1.5rem', fontWeight: 800, color: 'var(--gold)', lineHeight: 1 }}>
                2.5Lakh<span style={{ fontSize: '0.75rem', color: 'var(--lt)', fontWeight: 400 }}> Affordable Price</span>
              </div>
              <div style={{ fontSize: '0.75rem', color: 'var(--lt)', marginTop: '0.2rem' }}>Starting price</div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div style={{
          borderTop: '1px solid #1E2823',
          paddingTop: '2rem',
          display: 'flex', justifyContent: 'space-between', alignItems: 'center',
          flexWrap: 'wrap', gap: '1rem',
        }}>
          <p style={{ fontSize: '0.88rem', fontWeight: 500, color: 'var(--lt)' }}>
            © {new Date().getFullYear()} Muster Construct & Consultancy Services. All rights reserved. | KARTHIKEYAN.R BE (Proprietor)
          </p>
          <div style={{ display: 'flex', gap: '1rem' }}>
            {[
              { id: 'FB', img: fbicon, url: '#' },
              { id: 'WA', img: whatsappicon, url: 'https://wa.me/918056332329' },
              { id: 'IN', img: instaicon, url: '#' },
              { id: 'YT', img: yticon, url: '#' }
            ].map(s => (
              <a key={s.id} href={s.url} target="_blank" rel="noopener noreferrer" style={{
                display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                transition: 'transform .2s',
                background: 'none',
                border: 'none',
                boxShadow: 'none',
                cursor: 'pointer',
                lineHeight: 0,
              }}
                onMouseEnter={(e) => { e.currentTarget.style.transform = 'translateY(-3px)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.transform = 'none'; }}
              >
                <img
                  src={s.img}
                  alt={s.id}
                  style={{
                    width: s.id === 'WA' ? 35 : 32,
                    height: s.id === 'WA' ? 35 : 32,
                    objectFit: 'contain',
                    display: 'block'
                  }}
                />
              </a>
            ))}
          </div>
        </div>
      </div>

      <style>{`
        @media(max-width:900px){.fg-grid{grid-template-columns:1fr 1fr!important}}
        @media(max-width:500px){.fg-grid{grid-template-columns:1fr!important}}
      `}</style>
    </footer>
  );
}
